import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { AdminProductsList } from '../../../../components/admin-dashboard-component/admin-products-list/admin-products-list';
import { RouterLink } from '@angular/router';
import { ProductService } from '../../../../services/product/product.service';
import { ProductListItem } from '../product.model';
import { OrderBy } from './view-all-products.model';
import { finalize } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { SCOPES } from '../../../../services/scope/scope-constants';
import { HasScopeDirective } from '../../../../services/scope/has-scope.directive';

@Component({
  selector: 'app-view-all-products',
  imports: [AdminProductsList, RouterLink ,HasScopeDirective,
  ],
  templateUrl: './view-all-products.html',
  styleUrl: './view-all-products.scss',
})
export class ViewAllProducts {

  readonly SCOPES = SCOPES;


  // private productsService = inject(ProductService);
  // private destroyRef = inject(DestroyRef);
  // loading = signal<boolean>(false);
  // errorGettingProducts = signal<string | null>(null);
  // products = signal<ProductListItem[]>([]);
  // Filters and Pagination Signals
  // productTitle = signal<string | null>(null);
  // mfgCompanyId = signal<number | null>(null);
  // formId = signal<number | null>(null);
  // categoryId = signal<number | null>(null);
  // peoplePriceFrom = signal<number | null>(null);
  // peoplePriceTo = signal<number | null>(null);
  // pharmacyPriceFrom = signal<number | null>(null);
  // pharmacyPriceTo = signal<number | null>(null);
  // expireDateFrom = signal<string | null>(null);
  // expireDateTo = signal<string | null>(null);
  // pageNum = signal<number>(1);
  // pageOffset = signal<number>(0);
  // pageSize = signal<number>(10);
  // orderBy = signal<OrderBy | null>(null);
  // orderDir = signal<'ASC' | 'DESC' | null>(null);
  // totalPages = signal<number>(0);
  // currentPage = signal<number>(0);
  // FILTER FORM
  // filterForm = new FormGroup({});
  // fetchProducts() {
  //   return this.productsService.getAllProductsByFilter({
  //     productTitle: this.productTitle() as string,
  //     mfgCompanyId: this.mfgCompanyId() as number,
  //     formId: this.formId() as number,
  //     categoryId: this.categoryId() as number,
  //     peoplePriceFrom: this.peoplePriceFrom() as number,
  //     peoplePriceTo: this.peoplePriceTo() as number,
  //     pharmacyPriceFrom: this.pharmacyPriceFrom() as number,
  //     pharmacyPriceTo: this.pharmacyPriceTo() as number,
  //     expireDateFrom: this.expireDateFrom() as string,
  //     expireDateTo: this.expireDateTo() as string,
  //     pageNum: this.pageNum() as number,
  //     pageOffset: this.pageOffset() as number,
  //     pageSize: this.pageSize() as number,
  //     orderBy: this.orderBy() as OrderBy,
  //     orderDir: this.orderDir() as 'ASC' | 'DESC',
  //   });
  // }
  // ngOnInit(): void {
  //   console.log('test');
  //   this.loading.set(true);
  //   const subscribtion = this.fetchProducts()
  //     .pipe(
  //       finalize(() => {
  //         this.loading.set(false);
  //       }),
  //     )
  //     .subscribe({
  //       next: (res) => {
  //         console.log('products fetched: ', res);
  //         this.products.set(res.list);
  //       },
  //       error: (err) => {
  //         console.log('error: ', err);
  //         this.errorGettingProducts.set('Error fetching products. Please try again later.');
  //       },
  //     });
  //   this.destroyRef.onDestroy(() => subscribtion.unsubscribe());
  // }
  // nextSlide() {
  //   if (this.currentPage() < this.totalPages() - 1) {
  //     this.currentPage.set(this.currentPage() + 1);
  //     this.pageOffset.set(this.pageOffset() + this.pageSize());
  //     const subscribtion = this.fetchProducts()
  //       .pipe(
  //         finalize(() => {
  //           this.loading.set(false);
  //         }),
  //       )
  //       .subscribe({
  //         next: (data) => {
  //           console.log('data p2: ', data);
  //           this.products.set(data.list);
  //           this.totalPages.set(Math.ceil(data.total / this.pageSize()));
  //         },
  //         error: () => {
  //           this.errorGettingProducts.set("Couldn't fetch products. Please try again later.");
  //         },
  //       });
  //     this.destroyRef.onDestroy(() => subscribtion.unsubscribe());
  //   }
  // }
  // prevSlide() {
  //   console.log('Current Page: ', this.currentPage());
  //   if (this.currentPage() <= this.totalPages() - 1 && this.currentPage() >= 1) {
  //     this.currentPage.set(this.currentPage() - 1);
  //     this.pageOffset.set(this.pageOffset() - this.pageSize());
  //     const subscribtion = this.fetchProducts()
  //       .pipe(
  //         finalize(() => {
  //           this.loading.set(false);
  //         }),
  //       )
  //       .subscribe({
  //         next: (data) => {
  //           console.log('Fetched Categories Data:', data);
  //           this.products.set(data.list);
  //           this.totalPages.set(Math.ceil(data.total / this.pageSize()));
  //         },
  //         error: () => {
  //           this.errorGettingProducts.set("Couldn't fetch products. Please try again later.");
  //         },
  //       });
  //     this.destroyRef.onDestroy(() => subscribtion.unsubscribe());
  //   }
  // }
  // onApplyFilter(filterValues: { name: string; from: string; to: string }) {
  //   //  this.filterDate.set(filterValues);
  //   const subscribtion = this.fetchProducts()
  //     .pipe(
  //       finalize(() => {
  //         this.loading.set(false);
  //       }),
  //     )
  //     .subscribe({
  //       next: (data) => {
  //         console.log('Fetched Categories Data:', data);
  //         this.products.set(data.list);
  //         this.totalPages.set(Math.ceil(data.total / this.pageSize()));
  //       },
  //       error: () => {
  //         this.errorGettingProducts.set("Couldn't fetch products. Please try again later.");
  //       },
  //     });
  //   this.destroyRef.onDestroy(() => subscribtion.unsubscribe());
  //   // this.applyingFilter.set(false);
  // }
}
